// @ts-check
import {
  ConfigurationParameterReturnType,
  ConfigurationParameterSource,
} from '../enums';
import { defineConfig } from '../helpers';

export function common() {
  return defineConfig({
    PermitirEstablecerEntornoDeTrabajo: {
      source: ConfigurationParameterSource.WebService,
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
    },
    ForzarVisibilidadBarraInformativa: {
      source: ConfigurationParameterSource.WebService,
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      info: 'Fuerza la visualización de la barra informativa. Prevalece sobre la configuración del usuario.',
    },
  });
}
